class KlaviyoBIS extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.selectVariant = this.querySelector("select");
    this.buttonSubmit = this.querySelector(".js-button-submit");
    this.message = this.querySelector(".js-message");
    this.telInput = this.querySelector("input[name='phone_number']");

    this.form.addEventListener("submit", this.onSubmitForm.bind(this));

    this.updateVariantSelected();
    document.body.addEventListener("modalClosed", () => {
      this.message.classList.remove("success");
      this.message.classList.remove("error");
    });
  }

  connectedCallback() {
    this.iti = window.intlTelInput(this.telInput, {
      initialCountry: 'gb',
      separateDialCode: true,
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.5.0/build/js/utils.js",
    });
  }

  updateVariantSelected() {
    const variantSelector = document.querySelector("variant-radios");

    variantSelector &&
      variantSelector.addEventListener("change", () => {
        const currentVariant = variantSelector.currentVariant;

        if (currentVariant) {
          this.selectVariant.value = currentVariant.id;
        }
      });
  }

  async onSubmitForm(event) {
    event.preventDefault();

    // Validate the phone number
    if (!this.iti.isValidNumber()) {
      this.message.classList.add("error");
      this.message.classList.remove("success");
      this.message.innerHTML = "Please enter a valid phone number.";
      return;
    } else {
      this.message.innerHTML = "";
      this.message.classList.remove("error")
    }

    this.toggleLoadingButton();
    const formData = new FormData(this.form);
    const URL = "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + window.klaviyoId.publicId;
    const listURL =
      "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
    const params = new URLSearchParams();

    params.append("a", window.klaviyoId.publicId);
    params.append("g", window.klaviyoId.bisListId);
    params.append("platform", "shopify");
    for (const [name, value] of formData) {
      params.append(name, value);
    }

    const phoneNumber = this.iti.getNumber();

    console.log('phoneNumber', phoneNumber);

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: formData.get("email"),
                phone_number: phoneNumber,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${formData.get("variant")}`,
            },
          },
        },
      },
    };

    const config = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "revision":"2024-06-15"
      },
      body: JSON.stringify(payload),
    };
    const request = await fetch(URL, config)
    
    this.toggleLoadingButton();
    if (request.ok) {
      this.message.classList.add("success");
      this.message.classList.remove("error");
      this.message.innerHTML = `You are in! We will let you know when it's back.`;
    } else {
      this.message.classList.add("error");
      this.message.classList.remove("success");
      this.message.innerHTML = 'Something went wrong. Please try again.';
    }

    const config2 = {
      method: 'POST',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: params
    }
    fetch(listURL, config2)
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
      });
  }

  toggleLoadingButton() {
    if (this.buttonSubmit.classList.contains("loading")) {
      this.buttonSubmit.classList.remove("loading");
      this.buttonSubmit.querySelector("div").classList.add("hidden");
    } else {
      this.buttonSubmit.classList.add("loading");
      this.buttonSubmit.querySelector("div").classList.remove("hidden");
    }
  }
}

if (!customElements.get("klaviyo-bis")) {
  customElements.define("klaviyo-bis", KlaviyoBIS);
}
